import React, { useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { ImageMap } from "@qiuz/react-image-map";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import CircularProgress from "@mui/material/CircularProgress";

// Styling for the Segment Control
const HealthImage = ({
  building,
  floor,
  selectedAllRooms,
  setRoom,
  setRooms,
  loadHealth,
  setSelectedAllRooms,
  rooms,
  setSelectedTime,
  date,
  setTooltipRoom,
  setTooltipPosition,
  showDetail,
  setShowDetail,
  selectedPattern,
  selectedKPI,
  tempUnit,
  heat,
  aqi,
  humidity,
  pm10,
  pm25,
  o3,
  co2,
  co,
  no2,
  radon,
  noise,
  light,
  tvoc,
  productivityPattern,
  vapingPattern,
  efficiencyPattern,
}) => {
  const [productivityStatus, setProductivityStatus] = useState({});
  const [productivityProblem, setProductivityProblem] = useState({});
  const [productivityRecommendation, setProductivityRecommendation] = useState(
    {}
  );
  const [vapingStatus, setVapingStatus] = useState({});
  const [vapingProblem, setVapingProblem] = useState({});
  const [vapingRecommendation, setVapingRecommendation] = useState({});
  const [efficiencyStatus, setEfficiencyStatus] = useState({});
  const [efficiencyProblem, setEfficiencyProblem] = useState({});
  const [efficiencyRecommendation, setEfficiencyRecommendation] = useState({});
  // const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  // Set the initial state of the map area
  const [mapArea, setMapArea] = useState(
    !floor
      ? []
      : floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,
            style: { border: "", zIndex: 100 },
            selected: false,
          };
        })
  );
  const [temperatureArea, setTemperatureArea] = useState([]);
  const [mapClick, setMapClick] = useState(null);
  const floorImage = useSelector(
    (state) => state.performanceDashboard.data?.floorImage
  );
  const dispatch = useDispatch();

  //Effect: Show the heatmap on floor plan based on selected pattern .
  useEffect(() => {
    if (floor) {
      let style = {};
      let styleKPI = {};
      let data = [];

      if (
        (Object.keys(heat).length !== 0 && temperatureArea.length === 0) ||
        selectedPattern !== null
      ) {
        // Pattern 1 Threshold
        let lightThreshold = 50; // default 200
        let coThreshold = 9; // default 9
        let pm25Threshold = 35; // default 12

        // Pattern 2 Threshold
        let TVOCThreshold = 6;
        let eCO2Threshold = 600;
        let PM10Threshold = 30;

        // Pattern 3 Threshold
        let lightThreshold2 = 50;
        let noOfPersonThreshold = 5;

        // Temperature Heatmap initial load + Pattern
        for (const [key, value] of Object.entries(heat)) {
          const room = floor.rooms.filter((r) => r.id == key)[0];
          if (!room) continue;

          let avgTemp = value.avg / value.count;

          if (tempUnit) {
            if (avgTemp < 60.8 || avgTemp > 75.2) {
              style = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 60.8 && avgTemp < 64.4) {
              style = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 64.4 && avgTemp <= 75.2) {
              style = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }
          } else {
            if (avgTemp < 16 || avgTemp > 24) {
              style = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 16 && avgTemp < 18) {
              style = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 18 && avgTemp <= 24) {
              style = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }
          }

          // Pattern 1 logic
          if (selectedPattern === 1 && productivityPattern) {
            console.log("productivityPatttern", productivityPattern);
            style = {};
            // Room 4381
            if (room.id === 4381) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                4381: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                4381: [],
              }));

              // Status Good
              if (
                productivityPattern["4381"]?.Light.avg /
                  productivityPattern["4381"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["4381"]?.CO.avg /
                  productivityPattern["4381"]?.CO.count <=
                  coThreshold &&
                productivityPattern["4381"]?.PM25.avg /
                  productivityPattern["4381"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4381: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4381: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["4381"]?.Light.avg /
                    productivityPattern["4381"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["4381"]?.CO.avg /
                    productivityPattern["4381"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["4381"]?.PM25.avg /
                    productivityPattern["4381"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["4381"] &&
                  productivityProblem["4381"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["4381"] &&
                  productivityProblem["4381"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["4381"] &&
                  (productivityProblem["4381"].includes("CO") ||
                    productivityProblem["4381"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4381: [
                      ...prevState["4381"],
                      "Bring more fresh air to room",
                    ],
                  }));
                }
              }
            }

            //Room 4382
            if (room.id === 4382) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                4382: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                4382: [],
              }));

              // Status Good
              if (
                productivityPattern["4382"]?.Light.avg /
                  productivityPattern["4382"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["4382"]?.CO.avg /
                  productivityPattern["4382"]?.CO.count <=
                  coThreshold &&
                productivityPattern["4382"]?.PM25.avg /
                  productivityPattern["4382"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4382: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4382: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["4382"]?.Light.avg /
                    productivityPattern["4382"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["4382"]?.CO.avg /
                    productivityPattern["4382"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["4382"]?.PM25.avg /
                    productivityPattern["4382"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["4382"] &&
                  productivityProblem["4382"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["4382"] &&
                  productivityProblem["4382"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["4382"] &&
                  (productivityProblem["4382"].includes("CO") ||
                    productivityProblem["4382"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4382: [
                      ...prevState["4382"],
                      "Bring more fresh air to room",
                    ],
                  }));
                }
              }
            }

            //Room 4383
            if (room.id === 4383) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                4383: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                4383: [],
              }));

              // Status Good
              if (
                productivityPattern["4383"]?.Light.avg /
                  productivityPattern["4383"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["4383"]?.CO.avg /
                  productivityPattern["4383"]?.CO.count <=
                  coThreshold &&
                productivityPattern["4383"]?.PM25.avg /
                  productivityPattern["4383"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4383: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4383: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["4383"]?.Light.avg /
                    productivityPattern["4383"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["4383"]?.CO.avg /
                    productivityPattern["4383"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["4383"]?.PM25.avg /
                    productivityPattern["4383"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["4383"] &&
                  productivityProblem["4383"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["4383"] &&
                  productivityProblem["4383"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["4383"] &&
                  (productivityProblem["4383"].includes("CO") ||
                    productivityProblem["4383"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4383: [
                      ...prevState["4383"],
                      "Bring more fresh air to room",
                    ],
                  }));
                }
              }
            }

            //Room 4384
            if (room.id === 4384) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                4384: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                4384: [],
              }));

              // Status Good
              if (
                productivityPattern["4384"]?.Light.avg /
                  productivityPattern["4384"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["4384"]?.CO.avg /
                  productivityPattern["4384"]?.CO.count <=
                  coThreshold &&
                productivityPattern["4384"]?.PM25.avg /
                  productivityPattern["4384"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4384: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  4384: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["4384"]?.Light.avg /
                    productivityPattern["4384"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["4384"]?.CO.avg /
                    productivityPattern["4384"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["4384"]?.PM25.avg /
                    productivityPattern["4384"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["4384"] &&
                  productivityProblem["4384"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["4384"] &&
                  productivityProblem["4384"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["4384"] &&
                  (productivityProblem["4384"].includes("CO") ||
                    productivityProblem["4384"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    4384: [
                      ...prevState["4384"],
                      "Bring more fresh air to room",
                    ],
                  }));
                }
              }
            }

            //Room 5251
            if (room.id === 5251) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                5251: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                5251: [],
              }));

              // Status Good
              if (
                productivityPattern["5251"]?.Light.avg /
                  productivityPattern["5251"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["5251"]?.CO.avg /
                  productivityPattern["5251"]?.CO.count <=
                  coThreshold &&
                productivityPattern["5251"]?.PM25.avg /
                  productivityPattern["5251"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  5251: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  5251: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["5251"]?.Light.avg /
                    productivityPattern["5251"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["5251"]?.CO.avg /
                    productivityPattern["5251"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["5251"]?.PM25.avg /
                    productivityPattern["5251"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["5251"] &&
                  productivityProblem["5251"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["5251"] &&
                  productivityProblem["5251"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["5251"] &&
                  (productivityProblem["5251"].includes("CO") ||
                    productivityProblem["5251"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    5251: [
                      ...prevState["5251"],
                      "Bring more fresh air to room",
                    ],
                  }));
                }
              }
            }

            // Room 11
            if (room.id === 11) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                11: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                11: [],
              }));

              // Status Good
              if (
                productivityPattern["11"]?.Light.avg /
                  productivityPattern["11"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["11"]?.CO.avg /
                  productivityPattern["11"]?.CO.count <=
                  coThreshold &&
                productivityPattern["11"]?.PM25.avg /
                  productivityPattern["11"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  11: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  11: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["11"]?.Light.avg /
                    productivityPattern["11"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["11"]?.CO.avg /
                    productivityPattern["11"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["11"]?.PM25.avg /
                    productivityPattern["11"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["11"] &&
                  productivityProblem["11"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["11"] &&
                  productivityProblem["11"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["11"] &&
                  (productivityProblem["11"].includes("CO") ||
                    productivityProblem["11"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "Bring more fresh air to room"],
                  }));
                }
              }
            }

            // // Room 12
            if (room.id === 12) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                12: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                12: [],
              }));

              // Status Good
              if (
                productivityPattern["12"]?.Light.avg /
                  productivityPattern["12"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["12"]?.CO.avg /
                  productivityPattern["12"]?.CO.count <=
                  coThreshold &&
                productivityPattern["12"]?.PM25.avg /
                  productivityPattern["12"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  12: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  12: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["12"]?.Light.avg /
                    productivityPattern["12"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["12"]?.CO.avg /
                    productivityPattern["12"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["12"]?.PM25.avg /
                    productivityPattern["12"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["12"] &&
                  productivityProblem["12"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["12"] &&
                  productivityProblem["12"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["12"] &&
                  (productivityProblem["12"].includes("CO") ||
                    productivityProblem["12"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "Bring more fresh air to room"],
                  }));
                }
              }
            }

            // // Room 13
            if (room.id === 13) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                13: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                13: [],
              }));

              // Status Good
              if (
                productivityPattern["13"]?.Light.avg /
                  productivityPattern["13"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["13"]?.CO.avg /
                  productivityPattern["13"]?.CO.count <=
                  coThreshold &&
                productivityPattern["13"]?.PM25.avg /
                  productivityPattern["13"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  13: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  13: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["13"]?.Light.avg /
                    productivityPattern["13"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["13"]?.CO.avg /
                    productivityPattern["13"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["13"]?.PM25.avg /
                    productivityPattern["13"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["13"] &&
                  productivityProblem["13"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["13"] &&
                  productivityProblem["13"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["13"] &&
                  (productivityProblem["13"].includes("CO") ||
                    productivityProblem["13"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "Bring more fresh air to room"],
                  }));
                }
              }
            }

            // // Room 14
            if (room.id === 14) {
              setProductivityProblem((prevState) => ({
                ...prevState,
                14: [],
              }));

              setProductivityRecommendation((prevState) => ({
                ...prevState,
                14: [],
              }));

              // Status Good
              if (
                productivityPattern["14"]?.Light.avg /
                  productivityPattern["14"]?.Light.count >=
                  lightThreshold &&
                productivityPattern["14"]?.CO.avg /
                  productivityPattern["14"]?.CO.count <=
                  coThreshold &&
                productivityPattern["14"]?.PM25.avg /
                  productivityPattern["14"]?.PM25.count <=
                  pm25Threshold
              ) {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  14: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setProductivityStatus((prevState) => ({
                  ...prevState,
                  14: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/productivity-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: Light < 200
                if (
                  productivityPattern["14"]?.Light.avg /
                    productivityPattern["14"]?.Light.count <
                  lightThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "Light"],
                  }));
                }

                // Reason: CO > 9
                if (
                  productivityPattern["14"]?.CO.avg /
                    productivityPattern["14"]?.CO.count >
                  coThreshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "CO"],
                  }));
                }

                // Reason: PM25 > 12
                if (
                  productivityPattern["14"]?.PM25.avg /
                    productivityPattern["14"]?.PM25.count >
                  pm25Threshold
                ) {
                  setProductivityProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "PM25"],
                  }));
                }

                //Recommendation
                if (
                  productivityProblem["14"] &&
                  productivityProblem["14"].length === 0
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "Meet WHO standards"],
                  }));
                }

                if (
                  productivityProblem["14"] &&
                  productivityProblem["14"].includes("Light")
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "Need more light"],
                  }));
                }

                if (
                  productivityProblem["14"] &&
                  (productivityProblem["14"].includes("CO") ||
                    productivityProblem["14"].includes("PM25"))
                ) {
                  setProductivityRecommendation((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "Bring more fresh air to room"],
                  }));
                }
              }
            }
          }

          // Pattern 2 logic
          if (selectedPattern === 2 && vapingPattern) {
            style = {};

            // Room 4381
            if (room.id === 4381) {
              setVapingProblem((prevState) => ({
                ...prevState,
                4381: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                4381: [],
              }));

              // Status Good
              if (
                vapingPattern["4381"]?.TVOC.avg /
                  vapingPattern["4381"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["4381"]?.eCO2.avg /
                  vapingPattern["4381"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["4381"]?.PM10.avg /
                  vapingPattern["4381"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4381: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4381: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["4381"]?.TVOC.avg /
                    vapingPattern["4381"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["4381"]?.eCO2.avg /
                    vapingPattern["4381"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["4381"]?.PM10.avg /
                    vapingPattern["4381"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["4381"] && vapingProblem["4381"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4381: [
                      ...prevState["4381"],
                      vapingProblem["4381"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["4381"] &&
                  vapingProblem["4381"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4381: [
                      ...prevState["4381"],
                      vapingProblem["4381"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4381: [
                      ...prevState["4381"],
                      "Levels in good health standards",
                    ],
                  }));
                }
              }
            }

            //Room 4382
            if (room.id === 4382) {
              setVapingProblem((prevState) => ({
                ...prevState,
                4382: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                4382: [],
              }));

              // Status Good
              if (
                vapingPattern["4382"]?.TVOC.avg /
                  vapingPattern["4382"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["4382"]?.eCO2.avg /
                  vapingPattern["4382"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["4382"]?.PM10.avg /
                  vapingPattern["4382"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4382: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4382: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["4382"]?.TVOC.avg /
                    vapingPattern["4382"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["4382"]?.eCO2.avg /
                    vapingPattern["4382"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["4382"]?.PM10.avg /
                    vapingPattern["4382"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["4382"] && vapingProblem["4382"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4382: [
                      ...prevState["4382"],
                      vapingProblem["4382"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["4382"] &&
                  vapingProblem["4382"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4382: [
                      ...prevState["4382"],
                      vapingProblem["4382"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4382: [
                      ...prevState["4382"],
                      "Levels in good health standards",
                    ],
                  }));
                }
              }
            }

            //Room 4383
            if (room.id === 4383) {
              setVapingProblem((prevState) => ({
                ...prevState,
                4383: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                4383: [],
              }));

              // Status Good
              if (
                vapingPattern["4383"]?.TVOC.avg /
                  vapingPattern["4383"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["4383"]?.eCO2.avg /
                  vapingPattern["4383"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["4383"]?.PM10.avg /
                  vapingPattern["4383"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4383: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4383: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["4383"]?.TVOC.avg /
                    vapingPattern["4383"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["4383"]?.eCO2.avg /
                    vapingPattern["4383"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["4383"]?.PM10.avg /
                    vapingPattern["4383"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["4383"] && vapingProblem["4383"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4383: [
                      ...prevState["4383"],
                      vapingProblem["4383"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["4383"] &&
                  vapingProblem["4383"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4383: [
                      ...prevState["4383"],
                      vapingProblem["4383"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4383: [
                      ...prevState["4383"],
                      "Levels in good health standards",
                    ],
                  }));
                }
              }
            }

            //Room 4384
            if (room.id === 4384) {
              setVapingProblem((prevState) => ({
                ...prevState,
                4384: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                4384: [],
              }));

              // Status Good
              if (
                vapingPattern["4384"]?.TVOC.avg /
                  vapingPattern["4384"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["4384"]?.eCO2.avg /
                  vapingPattern["4384"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["4384"]?.PM10.avg /
                  vapingPattern["4384"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4384: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  4384: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["4384"]?.TVOC.avg /
                    vapingPattern["4384"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["4384"]?.eCO2.avg /
                    vapingPattern["4384"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["4384"]?.PM10.avg /
                    vapingPattern["4384"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["4384"] && vapingProblem["4384"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4384: [
                      ...prevState["4384"],
                      vapingProblem["4384"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["4384"] &&
                  vapingProblem["4384"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4384: [
                      ...prevState["4384"],
                      vapingProblem["4384"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    4384: [
                      ...prevState["4384"],
                      "Levels in good health standards",
                    ],
                  }));
                }
              }
            }

            //Room 5251
            if (room.id === 5251) {
              setVapingProblem((prevState) => ({
                ...prevState,
                5251: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                5251: [],
              }));

              // Status Good
              if (
                vapingPattern["5251"]?.TVOC.avg /
                  vapingPattern["5251"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["5251"]?.eCO2.avg /
                  vapingPattern["5251"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["5251"]?.PM10.avg /
                  vapingPattern["5251"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  5251: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  5251: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["5251"]?.TVOC.avg /
                    vapingPattern["5251"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["5251"]?.eCO2.avg /
                    vapingPattern["5251"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["5251"]?.PM10.avg /
                    vapingPattern["5251"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["5251"] && vapingProblem["5251"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    5251: [
                      ...prevState["5251"],
                      vapingProblem["5251"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["5251"] &&
                  vapingProblem["5251"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    5251: [
                      ...prevState["5251"],
                      vapingProblem["5251"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    5251: [
                      ...prevState["5251"],
                      "Levels in good health standards",
                    ],
                  }));
                }
              }
            }

            // Room 11
            if (room.id === 11) {
              setVapingProblem((prevState) => ({
                ...prevState,
                11: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                11: [],
              }));

              // Status Good
              if (
                vapingPattern["11"]?.TVOC.avg /
                  vapingPattern["11"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["11"]?.eCO2.avg /
                  vapingPattern["11"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["11"]?.PM10.avg /
                  vapingPattern["11"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  11: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  11: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["11"]?.TVOC.avg /
                    vapingPattern["11"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["11"]?.eCO2.avg /
                    vapingPattern["11"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["11"]?.PM10.avg /
                    vapingPattern["11"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["11"] && vapingProblem["11"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    11: [
                      ...prevState["11"],
                      vapingProblem["11"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["11"] &&
                  vapingProblem["11"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    11: [
                      ...prevState["11"],
                      vapingProblem["11"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    11: [...prevState["11"], "Levels in good health standards"],
                  }));
                }
              }
            }

            // // Room 12
            if (room.id === 12) {
              setVapingProblem((prevState) => ({
                ...prevState,
                12: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                12: [],
              }));

              // Status Good
              if (
                vapingPattern["12"]?.TVOC.avg /
                  vapingPattern["12"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["12"]?.eCO2.avg /
                  vapingPattern["12"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["12"]?.PM10.avg /
                  vapingPattern["12"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  12: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  12: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["12"]?.TVOC.avg /
                    vapingPattern["12"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["12"]?.eCO2.avg /
                    vapingPattern["12"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["12"]?.PM10.avg /
                    vapingPattern["12"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["12"] && vapingProblem["12"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    12: [
                      ...prevState["12"],
                      vapingProblem["12"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["12"] &&
                  vapingProblem["12"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    12: [
                      ...prevState["12"],
                      vapingProblem["12"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    12: [...prevState["12"], "Levels in good health standards"],
                  }));
                }
              }
            }

            // // Room 13
            if (room.id === 13) {
              setVapingProblem((prevState) => ({
                ...prevState,
                13: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                13: [],
              }));

              // Status Good
              if (
                vapingPattern["13"]?.TVOC.avg /
                  vapingPattern["13"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["13"]?.eCO2.avg /
                  vapingPattern["13"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["13"]?.PM10.avg /
                  vapingPattern["13"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  13: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  13: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["13"]?.TVOC.avg /
                    vapingPattern["13"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["13"]?.eCO2.avg /
                    vapingPattern["13"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["13"]?.PM10.avg /
                    vapingPattern["13"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["13"] && vapingProblem["13"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    13: [
                      ...prevState["13"],
                      vapingProblem["13"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["13"] &&
                  vapingProblem["13"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    13: [
                      ...prevState["13"],
                      vapingProblem["13"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    13: [...prevState["13"], "Levels in good health standards"],
                  }));
                }
              }
            }

            // // Room 14
            if (room.id === 14) {
              setVapingProblem((prevState) => ({
                ...prevState,
                14: [],
              }));

              setVapingRecommendation((prevState) => ({
                ...prevState,
                14: [],
              }));

              // Status Good
              if (
                vapingPattern["14"]?.TVOC.avg /
                  vapingPattern["14"]?.TVOC.count <
                  TVOCThreshold &&
                vapingPattern["14"]?.eCO2.avg /
                  vapingPattern["14"]?.eCO2.count <
                  eCO2Threshold &&
                vapingPattern["14"]?.PM10.avg /
                  vapingPattern["14"]?.PM10.count <
                  PM10Threshold
              ) {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  14: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setVapingStatus((prevState) => ({
                  ...prevState,
                  14: "Bad",
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/vaping-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                // Reason: TVOC
                if (
                  vapingPattern["14"]?.TVOC.avg /
                    vapingPattern["14"]?.TVOC.count >
                  TVOCThreshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "TVOC"],
                  }));
                }

                // Reason: eCO2
                if (
                  vapingPattern["14"]?.eCO2.avg /
                    vapingPattern["14"]?.eCO2.count >
                  eCO2Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "eCO2"],
                  }));
                }

                // Reason: PM10
                if (
                  vapingPattern["14"]?.PM10.avg /
                    vapingPattern["14"]?.PM10.count >
                  PM10Threshold
                ) {
                  setVapingProblem((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "PM10"],
                  }));
                }

                //Recommendation
                if (vapingProblem["14"] && vapingProblem["14"].length > 1) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    14: [
                      ...prevState["14"],
                      vapingProblem["14"].join(" and ") +
                        " present -Vaping may be present",
                    ],
                  }));
                } else if (
                  vapingProblem["14"] &&
                  vapingProblem["14"].length === 1
                ) {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    14: [
                      ...prevState["14"],
                      vapingProblem["14"][0] +
                        "-levels not meeting health standards",
                    ],
                  }));
                } else {
                  setVapingRecommendation((prevState) => ({
                    ...prevState,
                    14: [...prevState["14"], "Levels in good health standards"],
                  }));
                }
              }
            }
          }

          // Pattern 3 logic
          if (selectedPattern === 3 && efficiencyPattern) {
            style = {};
            // Room 4381
            if (room.id === 4381) {
              setEfficiencyProblem((prevState) => ({
                ...prevState,
                4381: [],
              }));

              setEfficiencyRecommendation((prevState) => ({
                ...prevState,
                4381: [],
              }));

              // Status Good
              if (
                // (efficiencyPattern["4381"]?.Light.avg /
                //   efficiencyPattern["4381"]?.Light.count <=
                //   lightThreshold2 &&
                //   efficiencyPattern["4381"].NumberOfPersons.avg /
                //     efficiencyPattern["4381"].NumberOfPersons.count >=
                //     noOfPersonThreshold) ||
                // efficiencyPattern["4381"].Temperature.avg /
                //   efficiencyPattern["4381"].Temperature.count >
                //   22 ||
                // (efficiencyPattern["4381"].Temperature.avg /
                //   efficiencyPattern["4381"].Temperature.count <
                //   26 &&
                //   efficiencyPattern["4381"].NumberOfPersons.avg /
                //     efficiencyPattern["4381"].NumberOfPersons.count >=
                //     noOfPersonThreshold)
                efficiencyPattern["4381"]?.Light.avg /
                  efficiencyPattern["4381"]?.Light.count <
                50
              ) {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4381: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4381: "Bad",
                }));

                // Reason
                setEfficiencyProblem((prevState) => ({
                  ...prevState,
                  4381: [...prevState["4381"], "Energy saving possible"],
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/efficiency-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                //Recommendation
                if (
                  efficiencyProblem["4381"] &&
                  efficiencyProblem["4381"].length > 0
                ) {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4381: [
                      ...prevState["4381"],
                      "Implement best practice energy saving",
                    ],
                  }));
                } else {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4381: [...prevState["4381"], "Office is efficient"],
                  }));
                }
              }
            }

            //Room 4382
            if (room.id === 4382) {
              setEfficiencyProblem((prevState) => ({
                ...prevState,
                4382: [],
              }));

              setEfficiencyRecommendation((prevState) => ({
                ...prevState,
                4382: [],
              }));

              // Status Good
              if (
                // (efficiencyPattern["4382"]?.Light.avg /
                //   efficiencyPattern["4382"]?.Light.count <=
                //   lightThreshold2 &&
                //   efficiencyPattern["4382"].NumberOfPersons.avg /
                //     efficiencyPattern["4382"].NumberOfPersons.count >=
                //     noOfPersonThreshold) ||
                // efficiencyPattern["4382"].Temperature.avg /
                //   efficiencyPattern["4382"].Temperature.count >
                //   22 ||
                // (efficiencyPattern["4382"].Temperature.avg /
                //   efficiencyPattern["4382"].Temperature.count <
                //   26 &&
                //   efficiencyPattern["4382"].NumberOfPersons.avg /
                //     efficiencyPattern["4382"].NumberOfPersons.count >=
                //     noOfPersonThreshold)
                efficiencyPattern["4382"]?.Light.avg /
                  efficiencyPattern["4382"]?.Light.count <
                50
              ) {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4382: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4382: "Bad",
                }));

                // Reason
                setEfficiencyProblem((prevState) => ({
                  ...prevState,
                  4382: [...prevState["4382"], "Energy saving possible"],
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/efficiency-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                //Recommendation
                if (
                  efficiencyProblem["4382"] &&
                  efficiencyProblem["4382"].length > 0
                ) {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4382: [
                      ...prevState["4382"],
                      "Implement best practice energy saving",
                    ],
                  }));
                } else {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4382: [...prevState["4382"], "Office is efficient"],
                  }));
                }
              }
            }

            //Room 4383
            if (room.id === 4383) {
              setEfficiencyProblem((prevState) => ({
                ...prevState,
                4383: [],
              }));

              setEfficiencyRecommendation((prevState) => ({
                ...prevState,
                4383: [],
              }));

              // Status Good
              if (
                // (efficiencyPattern["4383"]?.Light.avg /
                //   efficiencyPattern["4383"]?.Light.count <=
                //   lightThreshold2 &&
                //   efficiencyPattern["4383"].NumberOfPersons.avg /
                //     efficiencyPattern["4383"].NumberOfPersons.count >=
                //     noOfPersonThreshold) ||
                // efficiencyPattern["4383"].Temperature.avg /
                //   efficiencyPattern["4383"].Temperature.count >
                //   22 ||
                // (efficiencyPattern["4383"].Temperature.avg /
                //   efficiencyPattern["4383"].Temperature.count <
                //   26 &&
                //   efficiencyPattern["4383"].NumberOfPersons.avg /
                //     efficiencyPattern["4383"].NumberOfPersons.count >=
                //     noOfPersonThreshold)
                efficiencyPattern["4383"]?.Light.avg /
                  efficiencyPattern["4383"]?.Light.count <
                50
              ) {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4383: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4383: "Bad",
                }));

                // Reason
                setEfficiencyProblem((prevState) => ({
                  ...prevState,
                  4383: [...prevState["4383"], "Energy saving possible"],
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/efficiency-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                //Recommendation
                if (
                  efficiencyProblem["4383"] &&
                  efficiencyProblem["4383"].length > 0
                ) {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4383: [
                      ...prevState["4383"],
                      "Implement best practice energy saving",
                    ],
                  }));
                } else {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4383: [...prevState["4383"], "Office is efficient"],
                  }));
                }
              }
            }

            //Room 4384
            if (room.id === 4384) {
              setEfficiencyProblem((prevState) => ({
                ...prevState,
                4384: [],
              }));

              setEfficiencyRecommendation((prevState) => ({
                ...prevState,
                4384: [],
              }));

              // Status Good
              if (
                // (efficiencyPattern["4384"]?.Light.avg /
                //   efficiencyPattern["4384"]?.Light.count <=
                //   lightThreshold2 &&
                //   efficiencyPattern["4384"].NumberOfPersons.avg /
                //     efficiencyPattern["4384"].NumberOfPersons.count >=
                //     noOfPersonThreshold) ||
                // efficiencyPattern["4384"].Temperature.avg /
                //   efficiencyPattern["4384"].Temperature.count >
                //   22 ||
                // (efficiencyPattern["4384"].Temperature.avg /
                //   efficiencyPattern["4384"].Temperature.count <
                //   26 &&
                //   efficiencyPattern["4384"].NumberOfPersons.avg /
                //     efficiencyPattern["4384"].NumberOfPersons.count >=
                //     noOfPersonThreshold)
                efficiencyPattern["4384"]?.Light.avg /
                  efficiencyPattern["4384"]?.Light.count <
                50
              ) {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4384: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  4384: "Bad",
                }));

                // Reason
                setEfficiencyProblem((prevState) => ({
                  ...prevState,
                  4384: [...prevState["4384"], "Energy saving possible"],
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/efficiency-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                //Recommendation
                if (
                  efficiencyProblem["4384"] &&
                  efficiencyProblem["4384"].length > 0
                ) {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4384: [
                      ...prevState["4384"],
                      "Implement best practice energy saving",
                    ],
                  }));
                } else {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    4384: [...prevState["4384"], "Office is efficient"],
                  }));
                }
              }
            }

            //Room 5251
            if (room.id === 5251) {
              setEfficiencyProblem((prevState) => ({
                ...prevState,
                5251: [],
              }));

              setEfficiencyRecommendation((prevState) => ({
                ...prevState,
                5251: [],
              }));

              // Status Good
              if (
                // (efficiencyPattern["5251"]?.Light.avg /
                //   efficiencyPattern["5251"]?.Light.count <=
                //   lightThreshold2 &&
                //   efficiencyPattern["5251"].NumberOfPersons.avg /
                //     efficiencyPattern["5251"].NumberOfPersons.count >=
                //     noOfPersonThreshold) ||
                // efficiencyPattern["5251"].Temperature.avg /
                //   efficiencyPattern["5251"].Temperature.count >
                //   22 ||
                // (efficiencyPattern["5251"].Temperature.avg /
                //   efficiencyPattern["5251"].Temperature.count <
                //   26 &&
                //   efficiencyPattern["5251"].NumberOfPersons.avg /
                //     efficiencyPattern["5251"].NumberOfPersons.count >=
                //     noOfPersonThreshold)
                efficiencyPattern["5251"]?.Light.avg /
                  efficiencyPattern["5251"]?.Light.count <
                50
              ) {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  5251: "Good",
                }));

                style = {
                  backgroundImage: `url("/images/icons/checkmark-icon.png"),radial-gradient(circle, rgba(124,252,0,1) ,rgba(124,252,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                };
              } else {
                // Update the status
                setEfficiencyStatus((prevState) => ({
                  ...prevState,
                  5251: "Bad",
                }));

                // Reason
                setEfficiencyProblem((prevState) => ({
                  ...prevState,
                  5251: [...prevState["5251"], "Energy saving possible"],
                }));

                // Applied Status Style
                style = {
                  backgroundImage: `url("/images/icons/efficiency-selected.png"), radial-gradient(circle, rgba(255,0,0,0.7) ,rgba(255,0,0,0) 70%)`,
                  backgroundSize: "30px, cover",
                  backgroundRepeat: "no-repeat, no-repeat",
                  backgroundPosition: "center, center",
                  animationName: "blink",
                  animationDuration: "1s",
                  animationIterationCount: "infinite",
                };

                //Recommendation
                if (
                  efficiencyProblem["5251"] &&
                  efficiencyProblem["5251"].length > 0
                ) {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    5251: [
                      ...prevState["5251"],
                      "Implement best practice energy saving",
                    ],
                  }));
                } else {
                  setEfficiencyRecommendation((prevState) => ({
                    ...prevState,
                    5251: [...prevState["5251"], "Office is efficient"],
                  }));
                }
              }
            }
          }

          data.push({
            ...room,
            left: room.leftPin,
            top: room.topPin,
            style: selectedPattern === 4 ? {} : style,
          });
        }

        // Temperature Heatmap
        if (selectedKPI === "Temperature") {
          for (const [key, value] of Object.entries(heat)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgTemp = value.avg / value.count;

            if (tempUnit) {
              if (avgTemp < 60.8 || avgTemp > 75.2) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(255, 0, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              } else if (avgTemp >= 60.8 && avgTemp < 64.4) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(255, 255, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              } else if (avgTemp >= 64.4 && avgTemp <= 75.2) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(0, 255, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              }
            } else {
              if (avgTemp < 16 || avgTemp > 24) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(255, 0, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              } else if (avgTemp >= 16 && avgTemp < 18) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(255, 255, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              } else if (avgTemp >= 18 && avgTemp <= 24) {
                styleKPI = {
                  background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                  cursor: "pointer",
                  color: `rgb(0, 255, 0)`,
                  borderRadius: "50%",
                  border: "",
                  zIndex: 0,
                };
              }
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // AQI Heatmap
        if (selectedKPI === "AQI") {
          for (const [key, value] of Object.entries(aqi)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgAQI = value.avg / value.count;
            if (avgAQI > 100 && avgAQI <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgAQI > 50 && avgAQI <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgAQI >= 0 && avgAQI <= 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // Humidity Heatmap
        if (selectedKPI === "Humidity") {
          for (const [key, value] of Object.entries(humidity)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgHum = value.avg / value.count;
            if (avgHum < 20 || avgHum > 60) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgHum >= 20 && avgHum < 30) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgHum >= 30 && avgHum <= 60) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // PM10 Heatmap
        if (selectedKPI === "PM10") {
          for (const [key, value] of Object.entries(pm10)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgTemp = value.avg / value.count;
            if (avgTemp > 100 && avgTemp <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp > 50 && avgTemp <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 0 && avgTemp <= 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // PM25 Heatmap
        if (selectedKPI === "PM25") {
          for (const [key, value] of Object.entries(pm25)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgTemp = value.avg / value.count;
            if (avgTemp > 50 && avgTemp <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp > 25 && avgTemp <= 50) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTemp >= 0 && avgTemp <= 25) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // TVOC Heatmap
        if (selectedKPI === "TVOC") {
          for (const [key, value] of Object.entries(tvoc)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgTVOC = value.avg / value.count;
            if (avgTVOC > 500 && avgTVOC <= 2000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTVOC > 200 && avgTVOC <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgTVOC >= 0 && avgTVOC <= 200) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // Light Heatmap
        if (selectedKPI === "Light") {
          for (const [key, value] of Object.entries(light)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgLight = value.avg / value.count;
            if (avgLight < 200 || avgLight > 1000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgLight >= 200 && avgLight <= 300) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgLight >= 0 && avgLight <= 200) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }
            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // Noise Heatmap
        if (selectedKPI === "Noise_Level") {
          for (const [key, value] of Object.entries(noise)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgNoise = value.avg / value.count;
            if (avgNoise > 55 && avgNoise <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgNoise > 35 && avgNoise <= 55) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgNoise >= 0 && avgNoise <= 35) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // O3 Heatmap
        if (selectedKPI === "O3") {
          for (const [key, value] of Object.entries(o3)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgO3 = value.avg / value.count;
            if (avgO3 > 240 && avgO3 <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgO3 > 180 && avgO3 <= 240) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgO3 >= 0 && avgO3 <= 180) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // CO2 Heatmap
        if (selectedKPI === "eCO2") {
          for (const [key, value] of Object.entries(co2)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgCO2 = value.avg / value.count;
            if (avgCO2 > 2000 && avgCO2 <= 5000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgCO2 > 1000 && avgCO2 <= 2000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgCO2 >= 0 && avgCO2 <= 1000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // CO Heatmap
        if (selectedKPI === "CO") {
          for (const [key, value] of Object.entries(co)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgCO = value.avg / value.count;
            if (avgCO > 35 && avgCO <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgCO > 9 && avgCO <= 35) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgCO >= 0 && avgCO <= 9) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // NO2 Heatmap
        if (selectedKPI === "NO2") {
          for (const [key, value] of Object.entries(no2)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;
            let avgNO2 = value.avg / value.count;
            if (avgNO2 > 100 && avgNO2 <= 500) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgNO2 > 40 && avgNO2 <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgNO2 >= 0 && avgNO2 <= 40) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }

        // Radon Heatmap
        if (selectedKPI === "Radon") {
          for (const [key, value] of Object.entries(radon)) {
            const room = floor.rooms.filter((r) => r.id == key)[0];
            if (!room) continue;

            let avgRadon = value.avg / value.count;
            if (avgRadon > 300 && avgRadon <= 1000) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 0, 0, 1), rgba(255, 0, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 0, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgRadon > 100 && avgRadon <= 300) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(255, 255, 0, 1), rgba(255, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(255, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            } else if (avgRadon >= 0 && avgRadon <= 100) {
              styleKPI = {
                background: `radial-gradient(circle, rgba(0, 255, 0, 1), rgba(0, 255, 0, 0) 70%)`,
                cursor: "pointer",
                color: `rgb(0, 255, 0)`,
                borderRadius: "50%",
                border: "",
                zIndex: 0,
              };
            }

            if (selectedKPI === "none") {
              styleKPI = {
                background: "none",
              };
            }

            data.push({
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: styleKPI,
            });
          }
        }
        setTemperatureArea(data);
      }
    }
  }, [
    heat,
    noise,
    light,
    productivityPattern,
    selectedPattern,
    selectedKPI,
    showDetail,
  ]);

  //Effect: On map click effect
  useEffect(() => {
    if (mapClick) {
      console.log("Test map click");
      dispatch(
        loadHealth(
          `between=${date[0]}--${
            date[1]
          }&params=Temperature,AQI,PM10,PM25,CO,NO2,eCO2,TVOC,Relative_Humidity,Noise_Level,Gas_Resistance,Pressure,Light,O3,Radon&${
            building ? `&building=${building?.id}` : ""
          }${floor ? `&floor=${floor?.id}` : ""}&roomsSelected=true${
            rooms !== null && rooms !== undefined && rooms.length
              ? `&rooms=${rooms.map((room) => room)}`
              : ""
          }`
        )
      );
    }
  }, [mapClick]);

  //Effect: Select/Deselect All
  useEffect(() => {
    if (floor) {
      // When all rooms are selected
      if (selectedAllRooms && selectedAllRooms === "true") {
        let areas = floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,

            // Hover the Area function
            onMouseOver: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = `rgba(${room.color}, 0.1)`;
                e.target.style.cursor = "pointer";
              }
              setTooltipRoom(room);
              setShowDetail(true);
            },

            // Leave the Area function
            onMouseOut: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = ``;
                e.target.style.cursor = "";
              }
              setShowDetail(false);
            },
            style: {
              border: `${
                selectedAllRooms === "true"
                  ? `2px solid rgba(${room.color})`
                  : `1px solid rgba(${room.color})`
              }`,
            },
            selected: selectedAllRooms === "true" ? true : false,
          };
        });

        setMapArea(areas);

        const allRooms = floor.rooms.map((room) => room.id);
        setRooms(allRooms);

        dispatch(
          loadHealth(
            `between=${date[0]}--${
              date[1]
            }&params=Temperature,AQI,PM10,PM25,CO,NO2,eCO2,TVOC,Relative_Humidity,Noise_Level,Gas_Resistance,Pressure,Light,O3,Radon&${
              building ? `&building=${building?.id}` : ""
            }${floor ? `&floor=${floor?.id}` : ""}`
          )
        );
      }
      // When all rooms are deselected
      else if (selectedAllRooms && selectedAllRooms === "false") {
        let areas = floor.rooms.map((room) => {
          return {
            ...room,
            left: room.leftPin,
            top: room.topPin,

            // Hover the Area function
            onMouseOver: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = `rgba(${room.color}, 0.1)`;
                e.target.style.cursor = "pointer";
              }
              setTooltipRoom(room);
              setShowDetail(true);
            },

            // Leave the Area function
            onMouseOut: (e) => {
              if (e.target.style.color !== `rgb(${room.color})`) {
                e.target.style.background = ``;
                e.target.style.cursor = "";
              }
              setShowDetail(false);
            },
            style: {
              border: `${
                selectedAllRooms === "true"
                  ? `2px solid rgba(${room.color})`
                  : `1px solid rgba(${room.color})`
              }`,
              background: null,
            },
            selected: selectedAllRooms === "true" ? true : false,
          };
        });

        setMapArea(areas);
        setRooms([9999]); // Set dummy room id to prevent retrieve all data or data for specific room
        dispatch(
          loadHealth(
            `between=${date[0]}--${
              date[1]
            }&params=Temperature,AQI,PM10,PM25,CO,NO2,eCO2,TVOC,Relative_Humidity,Noise_Level,Gas_Resistance,Pressure,Light,O3,Radon&${
              building ? `&building=${building?.id}` : ""
            }${floor ? `&floor=${floor?.id}` : ""}&roomsSelected=true${
              rooms !== null && rooms !== undefined && rooms.length
                ? `&rooms=[9999]`
                : ""
            }`
          )
        );
      }
    }
  }, [selectedAllRooms]);

    // <OverlayTrigger
            //   placement="top" // Show the tooltip straight up
            //   delay={{ show: 250, hide: 400 }}
            // >
            //   {/* Tooltip content */}
            //   <div
            //     className="d-flex p-3 tooltip-content"
            //     style={{
            //       top: `${-100}px`, // Use the y-coordinate of the tooltip position
            //       right:`0px`,
            //       zIndex: 1000,
            //       position:"absolute"
            //     }}
            //   >
            //     <div className="d-flex flex-column">
            //       {/* Room */}
            //       <Badge
            //         style={{ fontSize: "14px" }}
            //         variant="success"
            //       >
            //         Room: {selectedRoom.Room}
            //       </Badge>

            //       {/* Room Details */}
            //       {
            //         selectedPattern && selectedPattern !==4 &&(
            //           <div className="d-flex flex-column justify-content-start gap-2">
            //           <div className="mb-1">
            //             Area:{" "}
            //             {selectedRoom.id === 4381
            //               ? "100"
            //               : selectedRoom.id === 4382
            //               ? "200"
            //               : selectedRoom.id === 4383
            //               ? "300"
            //               : selectedRoom.id === 4384
            //               ? "250"
            //               : selectedRoom.id === 5251
            //               ? "150"
            //               : selectedRoom.id === 11
            //               ? "280"
            //               : selectedRoom.id === 12
            //               ? "190"
            //               : selectedRoom.id === 13
            //               ? "118"
            //               : selectedRoom.id === 14
            //               ? "129"
            //               : "N/A"}{" "}
            //             m2
            //           </div>
            //           <div className="mb-1">
            //             Status:
            //             {selectedPattern === 3 &&
            //             (selectedRoom.id === 11 ||
            //               selectedRoom.id === 12 ||
            //               selectedRoom.id === 13 ||
            //               selectedRoom.id === 14 ||
            //               selectedRoom.id === 5259)
            //               ? ` Inactive`
            //               : ` Active`}
            //           </div>
            //           {/* Pattern Selected */}
            //           <div>
            //             <span>Pattern: </span>
            //             {selectedPattern === 1 ? (
            //               <img
            //                 src="/images/icons/productivity-selected.png"
            //                 width={20}
            //                 style={{ marginLeft: "8px" }}
            //               />
            //             ) : selectedPattern === 2 ? (
            //               <img
            //                 src="/images/icons/vaping-selected.png"
            //                 width={20}
            //                 style={{ marginLeft: "8px" }}
            //               />
            //             ) : selectedPattern === 3 ? (
            //               <img
            //                 src="/images/icons/efficiency-selected.png"
            //                 width={20}
            //                 style={{ marginRight: "8px" }}
            //               />
            //             ) : (
            //               "None"
            //             )}
            //           </div>
            //           {/* Problem */}
            //           <div>
            //             Problem:
            //             <span style={{ marginLeft: "10px", fontSize: "16px" }}>
            //               {/* Pattern 1 */}
            //               {selectedPattern === 1 &&
            //               productivityStatus[selectedRoom.id] === "Bad"
            //                 ? [
            //                     productivityProblem[selectedRoom.id]?.includes(
            //                       "Light"
            //                     ) && "Light",
            //                     productivityProblem[selectedRoom.id]?.includes(
            //                       "CO"
            //                     ) && "CO",
            //                     productivityProblem[selectedRoom.id]?.includes(
            //                       "PM25"
            //                     ) && "PM25",
            //                   ]
            //                     .filter(Boolean)
            //                     .join(" , ")
            //                 : selectedPattern === 2 &&
            //                   vapingStatus[selectedRoom.id] === "Bad"
            //                 ? [
            //                     vapingProblem[selectedRoom.id]?.includes(
            //                       "TVOC"
            //                     ) && "TVOC",
            //                     vapingProblem[selectedRoom.id]?.includes(
            //                       "eCO2"
            //                     ) && "eCO2",
            //                     vapingProblem[selectedRoom.id]?.includes(
            //                       "PM10"
            //                     ) && "PM10",
            //                   ]
            //                     .filter(Boolean)
            //                     .join(" , ")
            //                 : selectedPattern === 3 &&
            //                   efficiencyStatus[selectedRoom.id] === "Bad"
            //                 ? efficiencyProblem[selectedRoom.id]
            //                 : "None"}
            //             </span>
            //           </div>
            //           {/* Recommendation */}
            //           <div className="d-flex flex-column">
            //             <div>Recommendation:</div>
            //             <span style={{ marginLeft: "10px", fontSize: "16px" }}>
            //               {selectedPattern === 1 &&
            //               productivityStatus[selectedRoom.id] === "Bad"
            //                 ? productivityRecommendation[selectedRoom.id]?.map(
            //                     (item) => {
            //                       return (
            //                         <p style={{ marginBottom: "0px" }}>
            //                           - {item}
            //                         </p>
            //                       );
            //                     }
            //                   )
            //                 : selectedPattern === 2 &&
            //                   vapingStatus[selectedRoom.id] === "Bad"
            //                 ? vapingRecommendation[selectedRoom.id]?.map(
            //                     (item) => {
            //                       return (
            //                         <p style={{ marginBottom: "0px" }}>
            //                           - {item}
            //                         </p>
            //                       );
            //                     }
            //                   )
            //                 : selectedPattern === 3 &&
            //                   efficiencyStatus[selectedRoom.id] === "Bad"
            //                 ? efficiencyRecommendation[selectedRoom.id]?.map(
            //                     (item) => {
            //                       return (
            //                         <p style={{ marginBottom: "0px" }}>
            //                           - {item}
            //                         </p>
            //                       );
            //                     }
            //                   )
            //                 : "None"}
            //             </span>
            //           </div>
            //           <Button variant="success" width={50}>
            //             Send alert
            //           </Button>
            //         </div>
            //         )
            //       }
            
            //     </div>
            //   </div>
            // </OverlayTrigger>

  return (
    <>
      {floorImage ? (
        <>
          <ImageMap
            className="usage-map"
            style={{
              width:"100%",
              height:"100%",
              objectFit:"contain"
            }}
            src={floorImage}
            map={[...temperatureArea, ...mapArea]}
            onMapClick={(area, index) => {
              // Stationary & Robot Room Type
              if (area.roomType !== "People Count - In/Out") {
                if (!area.selected) {
                  // Copy map areas
                  const modifiedAreas = [...mapArea];

                  // Modify the selected area's property selected and style
                  const modifiedArea = {
                    ...area,
                    selected: true,
                    style: {
                      border: `2px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  // Replace the selected area with the modified area
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;
                  setMapArea(modifiedAreas);

                  // Get the selected room id
                  const selectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];

                  // If room is not previously selected
                  const isRoomExist = rooms.find(
                    (room) => room.id === selectedRoom
                  );

                  // If room is not previously selected, add it to the rooms list
                  if (!isRoomExist) {
                    setRooms([...rooms, selectedRoom]);
                  }
                }

                // Area previously selected, when clicking on the area
                else {
                  //Logic 2
                  const modifiedArea = {
                    ...area,
                    selected: false,
                    style: {
                      border: `1px solid rgba(${area.color})`,
                      zIndex: 100,
                    },
                  };

                  const modifiedAreas = [...mapArea];
                  modifiedAreas[index - temperatureArea.length] = modifiedArea;

                  setMapArea(modifiedAreas);
                  const unselectedRoom =
                    modifiedAreas[index - temperatureArea.length]["id"];
                  const filteredRooms = rooms.filter(
                    (room) => room !== unselectedRoom
                  );

                  setRooms(filteredRooms);
                }

                setMapClick((prev) => prev + 1);
                setSelectedTime(date);
              }
            }}
          />
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default HealthImage;
